import type { CaldavAccount } from '@/api'
import { matchText } from '@/todos/fuzzy'

// From this many accounts on, the list page shows a search field.
export const ACCOUNT_SEARCH_MIN = 6

// The accounts a search keeps, best match first (name before url before user at one tier; a tier is how `matchText` matched:
// prefix, somewhere, letters in order); ties and an empty search keep the order of `accounts`.
export function searchAccounts(accounts: CaldavAccount[], query: string): CaldavAccount[] {
  const needle = query.trim().toLowerCase()
  if (!needle) return accounts
  const ranked: { account: CaldavAccount; rank: number; index: number }[] = []
  accounts.forEach((account, index) => {
    const fields = [account.name, account.url, account.username ?? '']
    const ranks = fields
      .map((text, field) => {
        const tier = text ? matchText(text, needle)?.tier : undefined
        return tier === undefined ? undefined : tier + field * 0.1
      })
      .filter((rank): rank is number => rank !== undefined)
    if (ranks.length) ranked.push({ account, rank: Math.min(...ranks), index })
  })
  ranked.sort((a, b) => a.rank - b.rank || a.index - b.index)
  return ranked.map((entry) => entry.account)
}
